import { RefObject, useRef } from 'react'

export function useFocusableElementRef<TElement extends HTMLElement>(): [RefObject<TElement>, () => void] {
  const ref = useRef<TElement>(null)

  return [ref, () => ref.current?.focus()]
}
